import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-gray-900 bg-[#0A0A0A] text-center" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <div className="flex justify-center items-center gap-6 mb-8 text-gray-300" data-id="element-84">
          <div className="flex items-center gap-2" data-id="element-85">
            <Lock className="w-4 h-4" data-id="element-86" />
            <span className="text-sm" data-id="element-87">Pago Seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-88">
            <ShieldCheck className="w-4 h-4" data-id="element-89" />
            <span className="text-sm" data-id="element-90">Garantía 30 Días</span>
          </div>
        </div>

        <p className="text-gray-400 text-sm" data-id="element-91">
          © {new Date().getFullYear()} Método Caudal. Todos los derechos
          reservados.
        </p>
        <p className="text-gray-400 text-xs mt-4 max-w-2xl mx-auto" data-id="element-92">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}